import { render, staticRenderFns } from "./ErrorByStatus.vue?vue&type=template&id=7670d994&"
import script from "./ErrorByStatus.vue?vue&type=script&lang=js&"
export * from "./ErrorByStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports